import styled, { keyframes } from 'styled-components'
import bgImg from './assets/bg.png'

export const Container = styled.div`
  background-color: #F6F6FA;
  display: flex;
  overflow: hidden;
  padding: 80px 24px;

  @media (max-width: 568px) {
    padding-block: 40px;
  }
`

export const Content = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: space-around;
  gap: 16px;
  margin-inline: auto;
  max-width: 1366px;
  width: 100%;

  @media (max-width: 911px) {
    flex-direction: column;
    gap: 32px;
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  & > h1 {
    color: #282733;
    font-size: 2rem;
    font-weight: 500;
  }

  & > div {
    min-height: 368px;
  }

  & > h6 {
    color: #282733;
    font-size: 1.125rem;
    font-weight: 600;
  }

  & > span {
    font-size: 16px;
    font-weight: 400;
  }

  @media (min-width: 912px) {
    max-width: 592px;
  }

  @media (max-width: 568px) {
    & > h1 {
      font-size: 1.5rem;
    }

    & > div {
      min-height: initial;
    }

    & > h6 {
      font-size: 1rem;
    }
  }
`

export const AccordionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & > ul {
    display: flex;
    flex-direction: column;
    gap: 8px;
    list-style: none;

    & > li {
      align-items: center;
      color: #282733;
      display: inline-flex;
      font-size: 1rem;
      gap: 12px;
    }
  }

  @media (max-width: 568px) {
    & > ul {
      & > li {
        font-size: 0.875rem;
      }
    }
  }
`

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

export const ImageContainer = styled.figure`
  align-items: center;
  background-color: #FFF;
  background-image: url(${bgImg});
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 24px;
  display: flex;
  justify-content: center;
  padding: 16px 24px;
  width: 100%;

  & > img {
    animation: ${fadeIn} 0.8s ease-in-out;
  }

  @media (max-width: 911px) {
    display: none;
  }
`
